import { Typography } from '@mui/material'
import { Button, Modal } from 'eezy-components'
import { Trans, useTranslation } from 'react-i18next'
import { Modals } from '../'

type Props = {
  toggleModal: (modal: Modals | undefined) => void
  closeAccount: () => void
  closingAccount: boolean
}

const CloseAccount = ({ toggleModal, closeAccount, closingAccount }: Props) => {
  const { t } = useTranslation()

  const contactUrl = (
    <a
      href="https://eezycontributors.zendesk.com/hc/en-us/requests/new"
      target="_blank"
      rel="noopener noreferrer"
    />
  )

  return (
    <>
      <Modal.Header>
        {t('application_rejected.modal.close_account_question')}
      </Modal.Header>
      <Modal.Body>
        <Typography variant="body1" textAlign="center">
          <Trans
            i18nKey={`application_rejected.modal.close_account_question_info`}
            components={{
              contactUrl,
            }}
          />
        </Typography>
        <Typography variant="body1" textAlign="center">
          {t('application_rejected.modal.are_you_sure')}
        </Typography>
      </Modal.Body>
      <Modal.Actions>
        <Button onClick={closeAccount} loading={closingAccount}>
          {t('application_rejected.modal.close_account')}
        </Button>
        <Button
          color="primary"
          onClick={() => toggleModal(undefined)}
          disabled={closingAccount}
        >
          {t('cancel')}
        </Button>
      </Modal.Actions>
    </>
  )
}

export default CloseAccount
